import { useGetIssuerShortname } from '../../../../../hooks/use-get-issuer-shortname';
import { useGetTheme } from '../../../../../hooks/use-get-theme';
import { useLocale } from '../../../../../locale/use-locale';
import { useNavigationMenu } from '../../../navigation-menu/hooks';

const useFooter = () => {
  const theme = useGetTheme();
  const issuerName = useGetIssuerShortname();
  const {
    data: navigationMenu,
    loading: navigationMenuLoading,
    error: navigationMenuError,
  } = useNavigationMenu();

  const { setLocale, availableLanguages } = useLocale();

  return {
    theme,
    shortname: issuerName,
    navigationMenu,
    navigationMenuLoading,
    navigationMenuError,
    availableLanguages,
    setLocale,
  };
};

export default useFooter;
